import i18n from '@/i18n/i18n'
import BulkFarmerLimitApplicationService from '@/services/admin/BulkFarmerLimitApplicationService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = []
export const allowedIncludes = []
export const allowedSorts = []
export const allowedAppends = []
export const namespaced = true
export const state = {
  bulkFarmerLimitApplications: [],
  meta: null
}

export const mutations = {
  SET_BULK_FARMER_LIMIT_APPLICATIONS(state, bulkFarmerLimitApplications) {
    state.bulkFarmerLimitApplications = bulkFarmerLimitApplications.data
    state.meta = bulkFarmerLimitApplications.meta
  }
}

export const actions = {
  getBulkFarmerLimitApplications({ commit, dispatch }, query) {
    let newQuery = build_query(
      query,
      allowedFilters,
      allowedIncludes,
      Object.keys(query).length !== 0 ? allowedSorts : '-created_at',
      allowedAppends
    )

    return new Promise((resolve, reject) => {
      BulkFarmerLimitApplicationService.getBulkFarmerLimitApplications(newQuery)
        .then(response => {
          commit('SET_BULK_FARMER_LIMIT_APPLICATIONS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
